export default "__VITE_ASSET__NnuS3UPB__"